import React from "react";
import PropTypes from "prop-types";
import styled from 'styled-components';
import xIcon from '../../assets/img/icon-close.svg';
export default class Modal extends React.Component {
  onClose = e => {
    this.props.onClose && this.props.onClose(e);
  };

  constructor(props) {
    super(props);


  }




  update(e, space, txt){
    if(this.pop.contains(e.target)){

    }

    }



  render() {

    if (!this.props.show) {
      return null;
    }
    return (
   <FlexBox>


      <RelativeBox ref={node => {this.pop = node}} >


      <ContainerModal>
      <HeadLining><h4>{this.props.headline}</h4></HeadLining>
      <ButtonClose onClick={this.onClose}> <ImageModal src={xIcon} alt="" title=""></ImageModal>
      <IconGeberit className="icon web20-icon web20-icon-icon icon--white web20-icon web20-icon-close"></IconGeberit>


            </ButtonClose>
        {this.props.innerContent}
      </ContainerModal>

      </RelativeBox>


   <BlackBox/>
      </FlexBox>
    );
  }
}

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
};
const FlexBox = styled.div`display: flex;
justify-content: center;
position: fixed;
left: 0px;
top: 0px;
z-index: 30;
width:100vw;
height:100vh;
padding:2rem;
overflow:scroll;
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  height:auto;
  width:auto;
  overflow:scroll;
}
`;
const IconGeberit = styled.i`
@font-face {
  font-family: 'geberitWeb20IconFont';
  src: local('geberitWeb20IconFont'), url('fonts/icons/geberitWeb20IconFont.ttf'), format('truetype');
}
display: inline-block;
line-height: 1;
vertical-align: middle;
font-family: 'geberitWeb20IconFont' !important;
font-style: normal;
font-weight: normal !important;
text-decoration: inherit;
text-transform: none;
text-rendering: auto;
content: '\f121'
`;
const BlackBox = styled.div`

   position: fixed;
   z-index:3;
   left: 0px;
   top: 0px;
   background-color:black;
   opacity:0.7;
   width:100vw;
   height:100vh;
`;
const RelativeBox = styled.div`
background:white;
z-index:30;
margin:auto;
max-width:80%;
padding-bottom:2rem;
@media (max-width: 900px) {
  max-width:90%;
}

`;


const HeadLining= styled.div`
padding:2%;
padding-bottom:1rem;
color:#004673;
font-size:19.5px;
font-weight:100 !important;
font-family:GROTESK Bold  !important;
`;

const ButtonClose = styled.button`
position:absolute;
right:0.5rem;
top:0.5rem;
background:transparent;
border:none;
font-size:2rem;
font-weight:700;
color: #004673;
`;

const ImageModal= styled.img`
width: 1.2rem;
display: block;
height: 1.2rem;
margin: 1rem;
cursor: pointer;
`;


const ContainerModal = styled.div`
position:relative;
padding:25px;
`;

